import { useContext } from "react";
import FilterContext from "common/FilterContext";

const useHoursOfReturnView = (returnView) => {
  const [getSettings] = useContext(FilterContext);

  return returnView === undefined || returnView === null
    ? undefined
    : getSettings(returnView)?.hours;
};

export default useHoursOfReturnView;
